window.reloadCittaFromProvincia = function(obj, target) {

    let options = '<option value>Seleziona una provincia o stato estero...</option>';
    $(target).html(options);
    if (!$(obj).val()) return;
    httpRequest(api_url+'cittaProvincia/'+$(obj).val(),{}, {type:'get'}).then(onResult => {
        if (onResult.result) {
            options = '<option value>Seleziona una città</option>';
            $.each(onResult.data.citta, (k,v) => {
                options += '<option value="' + v.ID + '">' + v.nome + '</option>';
            });
            $(target).html(options);
        }
    });

}
window.httpRequest = async function(url, postData, options) {
    return new Promise(function(resolve, reject) {
        var defaultOptions = {
            type: "post",
            datatype: "json",
            cache: false,
            async: true,
            showLoader: true,
            contentType: 'application/x-www-form-urlencoded',
            processData: true
        };

        if (typeof postData == 'undefined' || postData == null) {
            postData = {};
        }
        if (typeof options !== 'undefined') {
            defaultOptions = Object.assign({}, defaultOptions, options);
        }

        $.ajax({
            type: defaultOptions.type,
            url: url,
            dataType: defaultOptions.datatype,
            cache: false,
            async: true,
            contentType: defaultOptions.contentType,
            processData: defaultOptions.processData,
            data: postData,
            xhr: function() {
                var xhr = new window.XMLHttpRequest();
                xhr.upload.addEventListener("progress", function(evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = (evt.loaded / evt.total) * 100;
                        var event = new CustomEvent('onUploadFileProgress', {
                            bubbles: true,
                            detail: {
                                'action': url,
                                'progress': percentComplete,
                                'total': evt.total,
                                'loaded': evt.loaded
                            }
                        });
                        document.dispatchEvent(event);
                    }
                }, false);
                return xhr;
            },
            beforeSend: function(formData, jqForm, options) {
                if (typeof authToken !== 'undefined') {
                    formData.setRequestHeader("Authorization", authToken);
                }
                if (typeof guardAuthToken !== 'undefined') {
                    formData.setRequestHeader("Guard-Authorization", guardAuthToken);
                }
                if (typeof sessionType !== 'undefined') {
                    formData.setRequestHeader('Session', sessionType);
                }
                if (defaultOptions.showLoader) {
                    $('body').addClass('onLoading');
                }
            },
            success: function(dati) {
                var jsonDati = dati;
                resolve(jsonDati);
            },
            error: function(jqxhr, textstatus, errorthrown) {
                /**
                 * La validazione è andata in errore
                 */
                 if (jqxhr.status == 422) {
                    let jsonDati = {
                        result: false,
                        data: jqxhr.responseJSON.errors
                    };
                    return resolve(jsonDati);
                }

                /**
                 * La validazione è andata in errore
                 */
                 if (jqxhr.status == 403) {
                    let jsonDati = {
                        result: false,
                        error: 'Azione non permessa'
                    };
                    return resolve(jsonDati);
                }
                if (jqxhr.status == 401) {
                    /**
                     * Gestire azioni "Unauthorized"
                     * qui possiamo pensare a un logout automatico
                     */
                }
                reject(jqxhr);
            },
            complete: function() {
                if (defaultOptions.showLoader) {
                    $('body').removeClass('onLoading');
                }
                window.onkeydown = window.onfocus = null;
            }
        });
    });
}

window.setCookie = function(cname, cvalue, exdays, path) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    var domain = null;
    if (window.basePathDomain) {
        domain = ";domain=" + window.basePathDomain;
    }
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=" + path + (domain ? domain : "");
}

window.showError = function(error) {
    Swal.fire({
        title: '',
        html: error,
        icon: 'error',
        showCancelButton: false,
        customClass: {
            confirmButton: 'btn btn-danger',
        },
        buttonsStyling: false,
        confirmButtonText: "Ok",
    });
}

window.showWarning = function(error) {
    Swal.fire({
        title: '',
        html: error,
        icon: "warning",
        showCancelButton: false,
        customClass: {
            confirmButton: 'btn btn-warning',
        },
        buttonsStyling: false,
        confirmButtonText: "Ok",
    });
}


window.question = function(text, respons, option) {
    if (typeof option === 'undefined' || option == null) {
        option = {};
    }
    if (option.title === 'undefined' || option.title == null) {
        option.title = '';
    }
    if (text === 'undefined' || text == null) {
        option.html = 'Confermi di voler eliminare l\'elemento selezionato?';
    } else {
        option.html = text;
    }
    if (option.icon === 'undefined' || option.icon == null) {
        option.icon = 'warning';
    }
    if (option.showCancelButton === 'undefined' || option.showCancelButton == null) {
        option.showCancelButton = true;
    }
    if (option.confirmButtonText === 'undefined' || option.confirmButtonText == null) {
        option.confirmButtonText = 'SI';
    }
    if (option.cancelButtonText === 'undefined' || option.cancelButtonText == null) {
        option.cancelButtonText = 'NO';
    }
    if (option.customClass === 'undefined' || option.customClass == null) {
        option.customClass = {
            confirmButton: 'btn btn-warning m-1 order-2',
            cancelButton: 'btn btn-light m-2 order-1',
            denyButton: 'btn btn-light m-2 order-1',
        };
    } else {
        if (option.customClass.confirmButton === 'undefined' || option.customClass.confirmButton == null) {
            option.customClass.confirmButton = 'btn btn-warning m-2 order-2';
        }
        if (option.customClass.cancelButton === 'undefined' || option.customClass.cancelButton == null) {
            option.customClass.cancelButton = 'btn btn-light m-2 order-1';
        }
        if (option.customClass.denyButton === 'undefined' || option.customClass.denyButton == null) {
            option.customClass.denyButton = 'btn btn-light m-2 order-1';
        }
    }
    option.buttonsStyling = false;
    option.heightAuto = false;

    Swal.fire(option).then((confirm) => {
        if (confirm.isConfirmed || confirm.isDenied) {
            respons(confirm)
        }
    });
}

window.hexToRgb = function(c) {
    if (/^#([a-fA-F0-9]{3}){1,2}$/.test(c)) {
        if (c.length == 4) {
            c = '#' + [c[1], c[1], c[2], c[2], c[3], c[3]].join('');
        }
        c = '0x' + c.substring(1);
        return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',');
    }
    return '';
}

window.rgbToHex = function(r, g, b) {
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

window.formatBytes = function(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

window.download_file = function(complete_path, nome_file, url) {
    $('body').append(
        `<div class="d-none" id="downloadForm">
        <form action="${base_url}${(url ? url : '')}" method="post">
            <input value="${complete_path}" name="path" >
            <input value="${nome_file}" name="nome" >
            <input type="hidden" name="_token" value="${(typeof csrf_token !== 'undefined' ? csrf_token : '' )}" />
            <button name="jqDownloadBtn" value="1"></button>
        </form>
        </div>`
    );
    $('button[name="jqDownloadBtn"]').click();
    $('#downloadForm').remove();
}

window.showToast = function(message, type, delay, html) {
    let delayString = '';
    if (!type) {
        type = 'success';
    }
    if (!delay && delay !== 0) {
        delay = 5000;
    }
    if (delay) {
        delayString = 'data-delay="' + delay + '"';
    }
    if (delay === 0) {
        delayString = 'data-autohide="false"';
    }
    if (html) {
        var toast = message;
    } else {
        var toast = '<div id="liveToast' + Date.now() + '" class="toast hide align-items-center text-white bg-' + type + ' border-0" role="alert" aria-live="assertive" aria-atomic="true" ' + delayString + '>' +
            '<div class="d-flex">' +
            '<div class="toast-body">' +
            message +
            '</div>' +
            '<button type="button" class="mr-2 mb-1 text-white close" data-dismiss="toast" aria-label="Close">' +
            '<span aria-hidden="true">&times;</span>' +
            '</button>' +
            '</div>' +
            '</div>';
    }
    var domToast = $(toast);
    $('.toast-wrapper').append(domToast);
    domToast.toast('show');
}

window.copyToClipboard = function(element) {
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(element).text()).select();
    document.execCommand("copy");
    $temp.remove();
}

window.copyValue = function(button, target) {
    const btnHtml = $(button).html();
    const valueItem = $(target).val();

    var textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;

    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textArea.style.width = '2em';
    textArea.style.height = '2em';

    // We don't need padding, reducing the size if it does flash render.
    textArea.style.padding = 0;

    // Clean up any borders.
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    /**
     * Deve essere visibile, altrimenti sbrocca male!
     */
    //textArea.style.display = 'none';
    textArea.style.boxShadow = 'none';

    // Avoid flash of the white box if rendered for any reason.
    textArea.style.background = 'transparent';


    textArea.value = valueItem;

    window.document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    window.document.execCommand('copy');
    window.document.body.removeChild(textArea);
    $(button).html('Copiato!');
    setTimeout(() => {
        $(button).html(btnHtml);
    }, 2000);
}

window.getCookie = function(c_name)
{
    var c_value = document.cookie;
    var c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1)
    {
        c_start = c_value.indexOf(c_name + "=");
    }
    if (c_start == -1)
    {
        c_value = null;
    }
    else
    {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1)
        {
            c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start,c_end));
    }
    return c_value;
}
window.setCookie = function(cname, cvalue, exdays, path, type) {
    //cookie di marketing
    if(!!type && type == 'm' && cookieObj && !cookieObj.accettaMarketing) return;
    //cookie funzionali
    if(!!type && type == 'f' && cookieObj && !cookieObj.accettaFunzionali) return;
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+d.toGMTString();
    var domain = '';
    if (window.basePathDomain) {
        domain = ";domain=" + window.basePathDomain;
    }
    document.cookie = cname + "=" + cvalue + "; " + expires + "; path=" + path + domain;
}
